export const okEmptyResponse = "OK";

export const apiProfile= "folderView_api_profile";

export enum impMode {exsistRev = 'exsistRev', newRev='newRev'}
export enum pdfMode {view = 'view', edit='edit'}

export enum currPathValue { 
        massUpdateRevisions = '/massUpdateRevisions',
        transferToProteknisk='/transferToProteknisk', 
        pdfConvert='/pdfConvert', 
        commentSheet = '/commentSheet',
        transferFromProtekniskToTos = '/transferFromProtekniskToTos', 
        transferHistoriskToFdv = '/transferHistoriskToFdv', 
    }

export enum docPathValue { 
        proteknisk = 'proteknisk',
        historisk='historisk', 
        fdv='fdv',
        none=''
    }

export enum containers {
    MAIN_CONTAINER = 'MAIN_CONTAINER',
    REVISION_LIST_CONTAINER = 'REVISION_LIST_CONTAINER',
    SAVE_REVISIONS = 'SAVE_REVISIONS',
    SEARCH_CONTAINER = 'SEARCH_CONTAINER',
    TRANSFER_FDV_CONTAINER = 'TRANSFER_FDV_CONTAINER',
    TRANSFER_DOCUMENTS = 'TRANSFER_DOCUMENTS',
    PDF_CONVERT_CONTAINER = 'PDF_CONVERT_CONTAINER',
    COMMENT_SHEET_CONTAINER = 'COMMENT_SHEET_CONTAINER'
}

export enum actionTypes {
    SET_LOADING = 'SET_LOADING',
    SET_VISIBLE = 'SET_VISIBLE',
    SET_ERRORED = 'SET_ERRORED',
    HAS_ACCESS = 'HAS_ACCESS',
    SET_USER = 'SET_USER',
    SET_APP_SETINGS = 'SET_APP_SETINGS',
    SET_ITEMS = 'SET_ITEMS',
    CLEAR_ITEMS = 'CLEAR_ITEMS',
    VISIBLE_TOGGLE = 'VISIBLE_TOGGLE'
}

export enum authResult {
    SET_SUCCESS = 'SET_SUCCESS',
    SET_ERRORED = 'SET_ERRORED',
}

export enum revMode {
    LATEST_REV = 'LATEST_REV',
    CURRENT_REV = 'CURRENT_REV',
}

export enum uiItemNames {
    errorMessage = 'errorMessage',
    dummy = 'dummy',
    infoContainerItems = 'infoContainerItems',
    documentList = 'documentList',
    documentListUpdate = 'documentListUpdate',
    statusCodes = 'statusCodes',
    newMetaItemValues = 'newMetaItemValues',
    revisionCodeValues = 'revisionCodeValues',
    archiveDefinition = 'archiveDefinition',
    revToUpdate = 'revToUpdate',
    errorMsgVisible = 'errorMsgVisible',
     levelToUpdate = 'levelToUpdate',
     MetaItemPresentations = 'MetaItemPresentations',
     MetaItemValidValues = 'MetaItemValidValues',
     documentListFileUpdate = 'documentListFileUpdate',
     DPI = 'DPI',
}

export enum buttonActionTypes  {
    GET_CONFIG = 'GET_CONFIG',
    TRANSFER_FROM_FDV_TO_TOS = 'TRANSFER_FROM_FDV_TO_TOS',
    TRANSFER_FROM_PROTECH_TO_TOS = 'TRANSFER_FROM_PROTECH_TO_TOS',
    CHECK_ACCESS_TO_EXTENTION = 'CHECK_ACCESS_TO_EXTENTION',
    GET_DOCUMENTS = 'GET_DOCUMENTS',
    GET_STATUS_CODES = 'GET_STATUS_CODES',
    GET_REVISION_CODES = 'GET_REVISION_CODES',
    SAVE_REVISION = 'SAVE_REVISION',
    GET_WEB_REQUEST = 'GET_WEB_REQUEST',
    GET_ARCHIVE = 'GET_ARCHIVE',
    TRANSFER_HISTORISK_DOCUMENTS = 'TRANSFER_HISTORISK_DOCUMENTS',
    GET_METAITEMPRESENTATION = 'GET_METAITEMPRESENTATION',
    GET_VALID_METAVALUES = 'GET_VALID_METAVALUES',
    SAVE_FILE = 'SAVE_FILE',
    CONVERT_FILE = 'CONVERT_FILE',
    VOID_FILE = 'VOID_FILE',
    UNDO_VOID_FILE = 'UNDO_VOID_FILE'
  }


